/**
 * Author：brand
 * Creation Time：2019-08-28 15:21
 * Email：brandhuang@qq.com
 */
import ax from '../axios'

/**
 * 登陆
 * @param params
 */
export function loginAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/ajax_clogin',
    method: 'POST',
    params
  })
}
/**
 * 查看历史
 * @param params
 */
export function getHistoryAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/history',
    method: 'POST',
    params
  })
}
/**
 * 发送图片
 * @param params
 */
export function sendImageMsgAPI (params) {
  return ax({
    url: '/wlapi/resource/uploadImgFile',
    method: 'POST',
    data: params
  })
}
/**
 * 发送文件
 * @param params
 */
export function sendFileMsgAPI (params) {
  return ax({
    url: '/wlapi/resource/uploadFile',
    method: 'POST',
    data: params
  })
}
/**
 * 发送视频
 * @param params
 */
export function sendVideoMsgAPI (params) {
  return ax({
    url: '/wlapi/resource/uploadVideoFile',
    method: 'POST',
    timeout: 100000,
    data: params
  })
}

/**
 * 上传进度
 * @param params
 * @returns {AxiosPromise}
 */
export function uploadProgressAPI (params) {
  return ax({
    url: '/wlapi/resource/item/percent',
    method: 'POST',
    data: params
  })
}
/**
 * 上传进度-重置
 * @param params
 * @returns {AxiosPromise}
 */
export function uploadProgressResetAPI (params) {
  return ax({
    url: '/wlapi/resource/percent/reset',
    method: 'POST',
    data: params
  })
}
/**
 * 发送语音
 * @param params
 */
export function sendVoiceMsgAPI (params) {
  return ax({
    url: '/wlapi/resource/uploadAudioFile',
    method: 'POST',
    data: params
  })
}
/**
 * (微信中)获取语音地址
 * @param params
 */
export function getVoiceInfoAPI (params) {
  return ax({
    url: '/wlapi/wx/getUploadUrl',
    method: 'POST',
    params
  })
}
/**
 * 评价
 * @param params
 */
export function chatEvaluateAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/submit_evaluate',
    method: 'POST',
    data: params
  })
}
/**
 * 留言
 * @param params
 */
export function chatLeaveMsgAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/submit_message',
    method: 'POST',
    params
  })
}
/**
 * 获取微信二维码和Q号
 * @param params
 */
export function getContactInfoAPI (params) {
  return ax({
    url: '/wlapi/widget/visitorGetAutoSet',
    method: 'POST',
    params
  })
}
/**
 * 获取初始信息（权限等）
 * @param params
 */
export function getInitialDataAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/ajax_clogin_initialize',
    method: 'POST',
    params
  })
}

/**
 * 获取微信配置
 * @param params
 */
export function getWechatConfigAPI (params) {
  return ax({
    url: '/wlapi/wx/configData',
    method: 'POST',
    params
  })
}
/**
 * （客服不在线时）查看历史聊天消息
 * @param params
 */
export function viewHisChatDataAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/visitorConv',
    method: 'POST',
    params
  })
}

/**
 * 机器人回答-已解决-未解决
 * @param params
 */
export function robotEvaluateAPI (params) {
  return ax({
    url: '/wlapi/robot/getRobotEvaluate',
    method: 'POST',
    params
  })
}
/**
 * 快捷评价-标签
 * @param params
 */
export function getQuickEvaluateAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/evaluateTags',
    method: 'POST',
    params
  })
}
/**
 * 订单-获取地址
 * @param params
 */
export function getAddressAPI (params) {
  return ax({
    url: '/wlapi/order/addressList',
    method: 'POST',
    params
  })
}
/**
 * 订单-确认地址
 * @param params
 */
export function confirmAddressAPI (params) {
  return ax({
    url: '/wlapi/order/confirmAddress',
    method: 'POST',
    params
  })
}
/**
 * 给您回电，提交手机号
 * @param params
 */
export function submitPhoneAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/submitPhone',
    method: 'POST',
    params
  })
}

/**
 * 获取广告
 * @param params
 */
export function getAddAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/visitorPageInfo',
    method: 'POST',
    params
  })
}


/**
 * 获取移动端自定义title
 * @param params
 */
export function getPageTitleAPI (params) {
  return ax({
    url: '/wlapi/pc_chat/visitorPageTitle',
    method: 'POST',
    params
  })
}

/**
 * 获取移动端快捷引导
 * @param params
 */
export function getVisitorQuickGuideAPI (params) {
  return ax({
    url: '/wlapi/quickguide/visitorQuickGuide',
    method: 'POST',
    params
  })
}

// ai客服转人工
export function transferToHumanAPI (params) {
  return ax({
    url: ' /wlapi/pc_chat/ai-turn-manual',
    method: 'POST',
    params
  })
}
